
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"m15.5 5.167-7 4.215-7-4.215m0-.883c0-.433.38-.784.848-.784h12.304c.468 0 .848.351.848.784v8.432c0 .433-.38.784-.848.784H2.348c-.468 0-.848-.351-.848-.784z"}})])
          )
        }
      }
    